import type { RouteLocationRaw } from '#vue-router';

export const productLPLinks: Record<
  Keys,
  {
    label: string;
    location: RouteLocationRaw;
  }
> = {
  nisa: {
    label: 'NISA',
    location: '/products/nisa',
  },
  ideco: {
    label: 'iDeCo',
    location: '/products/ideco',
  },
  asset: {
    label: '資産運用',
    location: '/products/asset',
  },
  investmenttrust: {
    label: '投資信託',
    location: '/products/investmenttrust',
  },
  educationFund: {
    label: '教育資金',
    location: '/products/education-fund',
  },
  retirement: {
    label: '老後資金',
    location: '/products/retirement',
  },
  marriageCost: {
    label: '結婚資金',
    location: '/products/marriage-cost',
  },
  childbirth: {
    label: '出産費用',
    location: '/products/childbirth',
  },
  mortgage: {
    label: '住宅ローン',
    location: '/products/mortgage',
  },
  lifeplan: {
    label: 'ライフプラン',
    location: '/products/lifeplan',
  },
  financeDiagnosis: {
    label: '家計診断',
    location: '/products/finance-diagnosis',
  },
  training: {
    label: 'お金の勉強',
    location: '/products/training',
  },
  insurance: {
    label: '保険',
    location: '/products/insurance',
  },
};

type Keys =
  | 'asset'
  | 'childbirth'
  | 'educationFund'
  | 'financeDiagnosis'
  | 'ideco'
  | 'insurance'
  | 'investmenttrust'
  | 'lifeplan'
  | 'marriageCost'
  | 'mortgage'
  | 'nisa'
  | 'retirement'
  | 'training';
